import { PromotionSettingSearchForm } from './PromotionSettingSearchForm'
import { withPromotionSettingSearchForm } from './withPromotionSettingSearchForm'

const ConnectedPromotionSettingSearchForm = withPromotionSettingSearchForm(
  PromotionSettingSearchForm
)

export { ConnectedPromotionSettingSearchForm as PromotionSettingSearchForm }
